/*
 * PLP Header — description disclosure (Read More / Read Less).
 * Scoped to the PLP section root (main-collection or main-search). On
 * collection layouts with `single` or `double` images, the description
 * block stacks collapsed + expanded states in a CSS grid cell so the
 * side-by-side image stays put when toggling (no JS measurement needed,
 * no reflow). The toggle swaps both `hidden` (browser inert) and
 * `aria-hidden` (drives CSS) on each state container; Tailwind
 * `aria-hidden:hidden` + `lg:aria-hidden:flex` / `lg:aria-hidden:invisible`
 * handle the CSS for both viewports.
 * Above the 2xl breakpoint (1512px) the disclosure is swapped out for a
 * full-text block entirely in CSS (see snippets/plp-header.liquid) — this
 * JS only wires the Read More / Less toggle for narrower viewports.
 * Listeners scoped via AbortController + cleaned up on
 * `shopify:section:unload` for theme editor / Section Rendering API.
 * Hooks: [data-plp-header-description-wrap], [-collapsed], [-expanded],
 *        [data-plp-header-readmore], [data-plp-header-readless].
 * TODO(i18n) — hardcoded 'Read More' / 'Read Less' labels in the Liquid.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-main-collection], [data-main-search]');
  if (!root) return;

  const abortController = new AbortController();
  const { signal } = abortController;

  // Sync `hidden` attribute + `aria-hidden` atomically so a11y state never drifts.
  function setDescriptionState(el, isHidden) {
    el.hidden = isHidden;
    if (isHidden) {
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.removeAttribute('aria-hidden');
    }
  }

  root.querySelectorAll('[data-plp-header-description-wrap]').forEach((wrap) => {
    const collapsed = wrap.querySelector('[data-plp-header-description-collapsed]');
    const expanded = wrap.querySelector('[data-plp-header-description-expanded]');
    const more = wrap.querySelector('[data-plp-header-readmore]');
    const less = wrap.querySelector('[data-plp-header-readless]');
    if (!collapsed || !expanded || !more || !less) return;

    more.addEventListener('click', () => {
      setDescriptionState(collapsed, true);
      setDescriptionState(expanded, false);
      more.setAttribute('aria-expanded', 'true');
      less.focus();
    }, { signal });

    less.addEventListener('click', () => {
      setDescriptionState(expanded, true);
      setDescriptionState(collapsed, false);
      more.setAttribute('aria-expanded', 'false');
      more.focus();
    }, { signal });
  });

  // Cleanup on Section Rendering API unload (theme editor reload, AJAX nav).
  document.addEventListener('shopify:section:unload', (e) => {
    if (e.target?.contains(root)) abortController.abort();
  }, { once: true });
})();
